export default class TextButton {
    constructor() {
        document.body.classList.add('overflow-hidden');
        this.fixedButtons = document.getElementById('botaoFixo');
        this.menuFixed = document.querySelector('.menu-fixo');


        setTimeout(() => {
            this.ready();
        }, 500);
        setTimeout(() => {
            document.body.classList.remove('overflow-hidden');
        }, 1000);
    }

    ready() {
        const posicaoElemento = this.fixedButtons.getBoundingClientRect();
        const posicaoX = posicaoElemento.left;
        const posicaoLeft = posicaoX + 'px';
        this.fixedButtons.style.left = posicaoLeft;

        window.onscroll = () => {
            checkScroll();

            this.menuFixed.classList.toggle('top-0', window.scrollY > 0);            
        };
    }
}

function findHeight() {
    const classesToCheck = [
        '.block-hero-with-slider',
        '.content-header',
        '.product-header',
        '.heroInternal',
        '.bigHeroInternal',
        '.menu-nav',
    ];

    const elementsWithHeight = classesToCheck.reduce((acc, className) => {
        const element = document.querySelector(className);
        if (element && element.classList.contains(className.substring(1))) {
            acc.push({ className, offsetHeight: element.offsetHeight });
        }
        return acc;
    }, []);

    return elementsWithHeight;
}

function checkScroll() {
    const elementsWithHeight = findHeight();

    elementsWithHeight.forEach((element) => {
        if (window.scrollY > element.offsetHeight) {
            document.getElementById('botaoFixo').classList.add('fixed', 'top-0', 'z-50', 'mt-32');
        } else {
            document.getElementById('botaoFixo').classList.remove('fixed', 'top-0', 'z-50', 'mt-32');
        }
    });
}

if (document.querySelector('#botaoFixo')) {
    new TextButton();
}
